module.exports = __webpack_public_path__ + "img/multiPlatforms.63d13736.png";